import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import clsx from "clsx"

import DoNotSellForm from "./forms/DoNotSell"

import "../styles/components/_bodyText.scss"

const BodyText = ({ text, className }) => {
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const {
          description: { "en-US": description },
          inputPlaceholder: { "en-US": placeholder },
          ctaText: { "en-US": ctaText },
        } = node.data.target.fields
        return (
          <DoNotSellForm formData={{ description, placeholder, ctaText }} />
        )
      },
    },
  }

  return (
    <div className={clsx("body-text", className)}>
      {documentToReactComponents(text, options)}
    </div>
  )
}

export default BodyText
